import { IMyHome } from '../../types/myHome';
import { noopReducer } from '../noopReducer';

const initialState: IMyHome = {
  showTrap: false,
};

export const myHomeReducer = noopReducer(initialState);
